import axios from "axios";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import swal from "sweetalert";
import CAPTCHATurnStile from "../admin/childComponents/appComponents/CAPTCHATurnStile";
import InputFieldLogin from "../admin/childComponents/inputComponents/InputFieldLogin";
import { useLocation } from "react-router-dom";

const BUTTON_NAME = "Request OPT";
const Register01 = (props) => {
  const location = useLocation();
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate("");

  const [reCaptcha, setReCaptcha] = useState(false);

  //Fetches all Form Data
  const [formData, setFormData] = useState({
    input: {
      email: null,
      reCaptcha: false,
    },
    select: {
      //department: null,
    },
  });

  // Reload Page
  const [reloadState, setReloadState] = useState({
    btnLoading: BUTTON_NAME,
    loading: BUTTON_NAME,
  });

  // Function to update form data dynamically
  const updateFormData = (type, key, value) => {
    setFormData((prev) => ({
      ...prev,
      [type]: {
        ...prev[type],
        [key]: value,
      },
    }));
  };

  async function resetPassword(event) {
    event.preventDefault();
    setReloadState((prev) => ({
      ...prev,
      loading: (
        <div>
          <i className="fa fa-refresh fa-spin"></i>
        </div>
      ),
    }));

    const datas = {
      email: formData.input.email,
    };

    await axios.get("sanctum/csrf-cookie").then((response) => {
      try {
        axios.post(BASE_URL + "account/validate", datas).then((res) => {
          if (res.data.status === 200) {
            console.log(res.data.message);

            localStorage.setItem("auth_email", res.data.authEmail);
            localStorage.setItem("auth_phone", res.data.authPhone);

            swal("Success", res.data.message, "success");
            setReloadState((prev) => ({
              ...prev,
              loading: BUTTON_NAME,
            }));
            navigate("/register02");
          } else if (res.data.status === 501) {
            localStorage.setItem("auth_email", res.data.authEmail);
            localStorage.setItem("auth_phone", res.data.authPhone);

            swal("Caution", res.data.message, "warning");
            navigate("/register02");
            setReloadState((prev) => ({
              ...prev,
              loading: BUTTON_NAME,
            }));
          } else {
            swal("Warning", res.data.message, "warning");

            setReloadState((prev) => ({
              ...prev,
              loading: BUTTON_NAME,
            }));
          }
        });
      } catch (error) {
        swal("Oops!", "Validation Failed", "error");
        setReloadState((prev) => ({
          ...prev,
          loading: BUTTON_NAME,
        }));
      }
    });
  }
  return (
    <>
      <h2 className="login-title">ADMIN REGISTRATION</h2>
      <p class="m-b-20">
        Enter your email address below and we'll send you an OPT to your
        registered phone and email, before you can continue.
      </p>
      <div className="form-group">
        <div className="input-group-icon right">
          <InputFieldLogin
            label="fa fa-envelope"
            name="email"
            size="14"
            placeholder="name@example.com"
            required="required"
            value={formData.input.email}
            type="email"
            onChange={updateFormData}
          />
        </div>
      </div>
      <div className="form-group">
        <CAPTCHATurnStile
                    reCaptcha={reCaptcha}
                    setReCaptcha={setReCaptcha}
                    captcha={location.pathname}
                  />
      </div>

      <div className="form-group">
        <div
          className="cf-turnstile"
          data-sitekey="{{Session::get('captch_key')}}"
          data-callback="javascriptCallback"
        ></div>
      </div>

      <div className="form-group">
        <button
          disabled={!reCaptcha}
          className="btn btn-primary col-12"
          onClick={resetPassword}
        >
          {reloadState.loading}
        </button>
      </div>

      <div className="social-auth-hr">
        <span>Follow Us On</span>
      </div>
      <div className="text-center social-auth m-b-20">
        <Link className="btn btn-social-icon btn-twitter m-r-5" to="#">
          <i className="fa fa-twitter"></i>
        </Link>
        <Link className="btn btn-social-icon btn-facebook m-r-5" to="#">
          <i className="fa fa-facebook"></i>
        </Link>
        <Link className="btn btn-social-icon btn-google m-r-5" to="#">
          <i className="fa fa-google-plus"></i>
        </Link>
        <Link className="btn btn-social-icon btn-linkedin m-r-5" to="#">
          <i className="fa fa-linkedin"></i>
        </Link>
      </div>

      <div className="card-footer text-center py-3 d-flex justify-content-between">
        <Link className="small" to="/login">
          Return to login
        </Link>
        <div className="small">
          <Link to="/forgotpassword01">Forgot password?</Link>
        </div>
      </div>
    </>
  );
};
export default Register01;
